module.exports = __webpack_public_path__ + "369dac81cbe0f2bab7a1d4f9f34d97da.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/abbvie_2023_chart.png
// module id = 1620
// module chunks = 0